// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"3f071860631117396ba6","339":"59dc0cf6e9ae4c1d055d"}[chunkId] + ".js";
};